<div class="container" fxLayout="column" fxLayoutAlign="space-evenly stretch">
    <h1 mat-dialog-title>{{ 'DocumentUpload'|translate }}</h1>

    <mat-dialog-content fxFlex>
      <input type="file" #file style="display: none;" (change)="onFilesAdded()" multiple />

      <mat-list *ngIf="files.size > 0">
        <mat-list-item class="document" *ngFor="let file of files">
          <mat-divider></mat-divider>
          <div class="document-container">
            <mat-icon mat-list-icon>attachment</mat-icon>
            <div class="document-details">
              <h4 class="document-title" mat-line>{{ file.name }}</h4>
              <mat-progress-bar class="document-progress" mat-line *ngIf="progress && (progress[file.name].observable | async); let data" mode="determinate" [value]="data.percent"></mat-progress-bar>
              <div class="document-errors" mat-line *ngIf="progress && (progress[file.name].observable | async) || {}; let data">
                <div *ngFor="let errors of data.errors | keyvalue">
                  {{ errors }}
                </div>
              </div>
            </div>
          </div>
        </mat-list-item>
      </mat-list>

      <p *ngIf="files.size == 0">{{ 'DocumentNoFileSelected' | translate }}</p>
    </mat-dialog-content>

    <mat-dialog-actions class="actions">
        <button mat-button mat-dialog-close>{{ 'Cancel'|translate }}</button>
        <button [disabled]="uploading || uploadSuccessful" mat-raised-button color="accent" class="add-files-btn" (click)="addFiles()">
            {{ 'DocumentAdd'|translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!canBeClosed || !hasFiles()" (click)="closeDialog()">{{primaryButtonText | translate}}</button>
    </mat-dialog-actions>
</div>
